import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import {
    NbActionsModule,
    NbCardModule,
    NbLayoutModule,
    NbMenuModule,
    NbRouteTabsetModule,
    NbSearchModule,
    NbSidebarModule,
    NbThemeModule,
    NbUserModule,
    NbProgressBarModule,
    NbButtonModule,
    NbInputModule,
    NbToastrModule,
    NbSpinnerModule,
    NbGlobalLogicalPosition,
    NbContextMenuDirective,
    NbContextMenuModule,
} from '@nebular/theme';

import {
    FooterComponent,
    HeaderComponent,
    SearchInputComponent,
    CustomModalComponent,
    SlideMenuModule,
} from './components';

import {
    CapitalizePipe,
    PluralPipe,
    RoundPipe,
    TimingPipe,
    NumberWithCommasPipe,
} from './pipes';

import {
    UnmaskDirective,
    DebounceClickDirective
} from './directives';

import {
    OneColumnLayoutComponent,
    SampleLayoutComponent,
    ThreeColumnsLayoutComponent,
    TwoColumnsLayoutComponent,
} from './layouts';

import { DEFAULT_THEME } from './styles/theme.default';
import { COSMIC_THEME } from './styles/theme.cosmic';
import { CORPORATE_THEME } from './styles/theme.corporate';

const BASE_MODULES = [
    CommonModule,
    FormsModule,
    SlideMenuModule,
    ReactiveFormsModule
];

const NB_MODULES = [
    NbCardModule,
    NbLayoutModule,
    NbRouteTabsetModule,
    NbMenuModule,
    NbUserModule,
    NbActionsModule,
    NbSearchModule,
    NbSidebarModule,
    NgbModule,
    NbProgressBarModule,
    NbButtonModule,
    NbToastrModule,
    NbInputModule,
    NbSpinnerModule,
    NbContextMenuModule
];

const COMPONENTS = [
    HeaderComponent,
    FooterComponent,
    SearchInputComponent,
    CustomModalComponent,
    OneColumnLayoutComponent,
    SampleLayoutComponent,
    ThreeColumnsLayoutComponent,
    TwoColumnsLayoutComponent,
];

const ENTRY_COMPONENTS = [
    CustomModalComponent
];

const DIRECTIVES = [
    UnmaskDirective,
    DebounceClickDirective
];

const PIPES = [
    CapitalizePipe,
    PluralPipe,
    RoundPipe,
    TimingPipe,
    NumberWithCommasPipe,
];

const NB_THEME_PROVIDERS = [
    ...NbThemeModule.forRoot({ name: 'default' }, [ DEFAULT_THEME, COSMIC_THEME, CORPORATE_THEME ]).providers,
    ...NbSidebarModule.forRoot().providers,
    ...NbMenuModule.forRoot().providers,
    ...NbToastrModule.forRoot({ position: NbGlobalLogicalPosition.BOTTOM_END }).providers,
    NgbActiveModal
    // ...NbDatepickerModule.forRoot().providers,
    // ...NbDialogModule.forRoot().providers,
    // ...NbWindowModule.forRoot().providers,
    // ...NbChatModule.forRoot({
    //   messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    // }).providers,
];

@NgModule({
    imports: [...BASE_MODULES, ...NB_MODULES],
    exports: [...BASE_MODULES, ...NB_MODULES, ...COMPONENTS, ...PIPES, ...DIRECTIVES],
    declarations: [...COMPONENTS, ...PIPES, ...DIRECTIVES],
    entryComponents: [...ENTRY_COMPONENTS],
})
export class ThemeModule {
    static forRoot(): ModuleWithProviders {
        return <ModuleWithProviders>{
            ngModule: ThemeModule,
            providers: [...NB_THEME_PROVIDERS],
        };
    }
}